import DecorativeEllipse from "@/components/DecorativeEllipse";

export default function FooterCta() {
  return (
    <section className="relative overflow-hidden" style={{ backgroundColor: "#141414" }}>
      {/* Decorative ellipses */}
      <DecorativeEllipse
        className="-top-32 -right-32"
        size={448}
        opacity={0.08}
        blur={140}
      />
      <DecorativeEllipse
        className="-bottom-40 -left-40"
        size={512}
        opacity={0.06}
        blur={160}
      />
      <DecorativeEllipse
        className="top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        size={700}
        opacity={0.03}
        blur={200}
      />

      {/* Gold gradient overlays */}
      <div className="absolute inset-0 bg-gradient-to-tr from-gold/[0.03] via-transparent to-gold/[0.02] pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-gold/[0.015] to-transparent pointer-events-none" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-8 py-16 md:py-24 text-center">
        <p className="font-sans text-sm md:text-base text-gold-muted mb-6 tracking-wide uppercase">
          Abundancia = más ingresos + más oportunidades + mejor gestión + más valor entregado
        </p>
        <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl text-cream mb-4 leading-snug">
          Tu próxima versión ya existe.
          <br />
          Solo falta que decidas acceder a ella.
        </h2>

        <a
          href="#pricing"
          className="inline-flex items-center justify-center gap-3 px-10 py-5 md:px-12 md:py-6 rounded-md font-sans font-semibold text-base md:text-lg text-white transition-all duration-300 hover:scale-[1.02] hover:brightness-110 mt-8"
          style={{ backgroundColor: "#2E7D32" }}
        >
          <span>Quiero acceso ahora</span>
          <i className="ri-arrow-right-line text-lg" />
        </a>

        <p className="mt-6 font-sans text-xs md:text-sm text-cream/40">
          Garantía de 7 días. Sin preguntas.
        </p>
      </div>
    </section>
  );
}